/**
 * Builds the query-tab content for reopening a closed tab — shared by the
 * Tab History dialog and the start page's Recent tabs list so both handle an
 * entry whose script was omitted from persistence the same way: a
 * placeholder body, no file binding (Save must not overwrite the real file),
 * and a `pendingFileReload` so a file-tied entry re-reads its script on mount.
 */

import type { TabHistoryEntry } from '../types/tabHistoryTypes';
import { buildOmittedScriptPlaceholder } from '../../../types/editorTextLimits';

export type ReopenedQueryContent = {
  query: string;
  filePath?: string;
  fileLastSavedHash?: string;
  pendingFileReload?: string;
};

export function tabHistoryEntryToQueryContent(entry: TabHistoryEntry): ReopenedQueryContent {
  if (entry.queryOmitted) {
    return {
      query: buildOmittedScriptPlaceholder(entry.filePath),
      ...(entry.filePath ? { pendingFileReload: entry.filePath } : {}),
    };
  }
  return {
    query: entry.query || '',
    ...(entry.filePath ? { filePath: entry.filePath } : {}),
    ...(entry.fileLastSavedHash ? { fileLastSavedHash: entry.fileLastSavedHash } : {}),
  };
}
